import { ApplicationAuth, useTenant } from '@emerald-works-nova/auth'
import { EventBusProvider } from '@emerald-works/react-event-bus-client'
import { CssBaseline } from '@mui/material'
import React from 'react'
import './app.css'
import { AppLoading, BannerStatic } from './components'
import { EventContextProvider } from './hooks/event'
import { routes } from './routes'
import { Outlet } from 'react-router'

const App = () => {
  const tenant = useTenant()
  return (
    <ApplicationAuth
      loginRoute={routes.login.path}
      signInPath={routes.signin.path}
      LoadingComponent={AppLoading}
      defaultTenantKey='admin'
      tenant={tenant}
    >
      <EventBusProvider
        eventBusURL={tenant.eventBusUrl || process.env.REACT_APP_EVENT_BUS_URL}
        connectionParams={{ tenantKey: tenant?.tenantKey }}
        useAuthProvider
        options={{
          socketIoUrl: process.env.REACT_APP_EVENT_BUS_BACKUP_URL || 'https://socketio.ewnova.dev'
        }}
        fetchUserProfile
        namespace='ark'
        LoadingComponent={<AppLoading />}
        onConnectionChange={(status) => console.log('Connection onConnectionChange hook with status:', status)}
        onOpen={() => console.log('Connection onOpen hook')}
        onClose={() => console.log('Connection onClose hook')}
      >
        <EventContextProvider>
          <CssBaseline />
          <BannerStatic />
          <Outlet />
        </EventContextProvider>
      </EventBusProvider>
    </ApplicationAuth>
  )
}

export default App
